
(function ($) {
    $(() => {

        if ($('.newsletter-fullscreen-modal').length === 0) {
            return;
        }

        if (Cookies.get("fullscreen_newsletter_closed")) {
            return;
        }

        if (localize.fullscreen_popup_active !== '1') {
            return;
        }

        $(".newsletter-fullscreen-modal").iziModal({
            width: 592,
            overlay: true,
            overlayClose: true,
            overlayColor: "rgba(0, 0, 0, 0.6)",
            radius: "0",
            onClosed: function () {
                Cookies.set('fullscreen_newsletter_closed', true, { expires: 1 });
            },
        });



        $(".newsletter-fullscreen-modal").iziModal('open');

        $('.js-fullscreen-modal-subscribe').on('click', (e) => {
            e.preventDefault();
            const $this = $(e.target);
            const $form = $this.closest('form');
            $form.submit();
        })

        let isButtonClick = false

        $('.js-fullscreen-newsletter-form').submit(function (e) {
            e.preventDefault();
            var $this = $(this);


            if (isButtonClick) {
                return false;
            }

            isButtonClick = true;

            $.ajax({
                type: "post",
                context: this,
                dataType: "json",
                url: localize.ajaxurl,
                data: {
                    action: "mailchimpsubscribe",
                    datas: $this.serializeArray(),
                },
                success: function (response) {
                    isButtonClick = false;

                    if (!response['fault']) {
                        $this.trigger('reset');
                        $('#fullscreen-dialog-content').removeClass('error');
                        $('#fullscreen-dialog-content p').html(response['msg']);
                        Fancybox.show([{ src: "#fullscreen-dialog-content", type: "inline" }]);

                        $(".newsletter-fullscreen-modal").iziModal('close');

                    } else {
                        if (response['mailchimp_error']) {
                            alert(response['msg']);
                        } else {
                            $('#fullscreen-dialog-content').addClass('error');
                            $('#fullscreen-dialog-content p').html(response['msg']);
                            Fancybox.show([{ src: "#fullscreen-dialog-content", type: "inline" }]);
                        }
                    }
                }
            });

            return false;

        });
    });
})(jQuery);
